import AssociationSeller from './WelcomeSellerModal'

export default AssociationSeller
